import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9","key":"svg-0"}],["path",{"d":"M5 21v-7","key":"svg-1"}]]

/**
 * IconFlag
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZmxhZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNSA1YTUgNSAwIDAgMSA3IDBhNSA1IDAgMCAwIDcgMHY5YTUgNSAwIDAgMSAtNyAwYTUgNSAwIDAgMCAtNyAwdi05IiAvPgogIDxwYXRoIGQ9Ik01IDIxdi03IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/flag
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFlag = createReactComponent('outline', 'flag', 'Flag', __iconNode);

export default IconFlag;